import apiClient from './apiClient';

export const vehicleService = {
  // Get all vehicles
  getAllVehicles: async (params = {}) => {
    try {
      const response = await apiClient.get('/vehicles', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get active vehicles (for tracking/DRS pickers)
  getActiveVehicles: async () => {
    try {
      const response = await apiClient.get('/vehicles/active');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get single vehicle
  getVehicle: async (id) => {
    try {
      const response = await apiClient.get(`/vehicles/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new vehicle
  createVehicle: async (vehicleData) => {
    try {
      const response = await apiClient.post('/vehicles', vehicleData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update vehicle
  updateVehicle: async (id, vehicleData) => {
    try {
      const response = await apiClient.put(`/vehicles/${id}`, vehicleData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete vehicle
  deleteVehicle: async (id) => {
    try {
      const response = await apiClient.delete(`/vehicles/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get vehicle statistics
  getVehicleStats: async () => {
    try {
      const response = await apiClient.get('/vehicles-data/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Toggle vehicle status
  toggleVehicleStatus: async (id) => {
    try {
      const response = await apiClient.post(`/vehicles/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};
